import React from "react";
import { FaTools, FaTruckMoving, FaShieldAlt } from "react-icons/fa";

const Home = () => {
  return (
    <div className="text-[#3d3d3f]">
      {/* Hero Section */}
      <section className="bg-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 space-y-6">
            <h1 className="text-4xl font-bold text-[#ae3e34]">
              Your One-Stop Construction Store
            </h1>
            <p className="text-lg text-gray-700">
              From bricks to cement, we deliver all your construction essentials
              with quality and reliability.
            </p>
            <button className="bg-[#ae3e34] text-white px-6 py-3 rounded-lg hover:bg-[#932f28] transition">
              Explore Products
            </button>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="https://thumbs.dreamstime.com/b/house-under-construction-blueprints-building-project-53360048.jpg"
              alt="Construction Materials"
              className="rounded-xl shadow-lg w-full md:w-auto"
            />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8">Why Choose BricksNBar?</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-10">
            <div className="flex flex-col items-center space-y-4">
              <FaTools size={40} className="text-[#ae3e34]" />
              <h3 className="font-semibold text-lg">Wide Product Range</h3>
              <p className="text-gray-600 text-sm">
                From bricks to cement, rods, tiles, sand, and more – find
                everything under one roof.
              </p>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <FaTruckMoving size={40} className="text-[#ae3e34]" />
              <h3 className="font-semibold text-lg">Timely Delivery</h3>
              <p className="text-gray-600 text-sm">
                We ensure on-time delivery to keep your construction schedule
                running smoothly.
              </p>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <FaShieldAlt size={40} className="text-[#ae3e34]" />
              <h3 className="font-semibold text-lg">Trusted Quality</h3>
              <p className="text-gray-600 text-sm">
                Sourced from top brands to ensure durability and performance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Preview */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8 text-center">
            Top Construction Materials
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8">
            {[
              "Bricks",
              "Cement",
              "Steel Rods",
              "Sand",
              "Tiles",
              "Gravel",
              "Paints",
              "Pipes",
            ].map((item) => (
              <div
                key={item}
                className="bg-white p-6 rounded-xl text-center shadow hover:shadow-md transition"
              >
                <h3 className="text-lg font-semibold mb-2">{item}</h3>
                <p className="text-sm text-gray-600">
                  High-quality {item.toLowerCase()} available.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-[#ae3e34] text-white py-12">
        <div className="max-w-6xl mx-auto px-4 text-center space-y-4">
          <h2 className="text-3xl font-bold">
            Start Your Construction with Confidence
          </h2>
          <p>Order your materials now or contact us for bulk quotations.</p>
          <button className="bg-white text-[#ae3e34] px-6 py-3 rounded-lg font-medium hover:bg-gray-200 transition">
            Contact Us
          </button>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10">What Our Customers Say</h2>
          <div className="grid sm:grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: "Rahul Sharma",
                text: "BricksNBar delivered everything right on time. Their service is super reliable and professional!",
              },
              {
                name: "Pooja Verma",
                text: "We ordered bulk cement and rods for our new site. The quality and pricing were unbeatable!",
              },
              {
                name: "Sanjay Patel",
                text: "As a contractor, I value speed and reliability — BricksNBar never disappoints.",
              },
            ].map(({ name, text }, idx) => (
              <div
                key={idx}
                className="bg-gray-100 rounded-xl p-6 shadow hover:shadow-md transition"
              >
                <p className="text-sm text-gray-700 mb-4">"{text}"</p>
                <h4 className="font-semibold text-[#ae3e34]">{name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Products */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10">Popular Products</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
            {[
              {
                name: "Red Clay Bricks",
                image: "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcTn3HAyEH_KBxruji5QkA_Aj5oy7-KmeNgQ3PKp25fj4EWrb-3HHNwUPrIiSHupQz6KO_6VpFJ77EQJTVJeET9hRTDnwVyfMw",
              },
              {
                name: "OPC Cement",
                image: "https://m.media-amazon.com/images/I/51-ALUOrA5L._AC_UF1000,1000_QL80_.jpg",
              },
              {
                name: "Steel Rods",
                image: "https://www.jkcement.com/wp-content/uploads/2024/10/cylindrical-steel-pipe-1024x724-jpg.webp",
              },
              {
                name: "Floor Tiles",
                image: "https://www.hindwareitaliantiles.com/HindwareItalianTilesBackEndImg/CategoryImages/floor-tiles.jpg",
              },
            ].map((product, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded-xl shadow hover:shadow-md transition"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-32 w-full object-cover rounded mb-4"
                />
                <h4 className="font-semibold mb-1">{product.name}</h4>
                <p className="text-sm text-gray-600">
                  Premium quality, best price.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-12">How It Works</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-10 text-left">
            {[
              {
                title: "Browse Products",
                desc: "Explore a wide range of construction materials tailored to your needs.",
                icon: "🛒",
              },
              {
                title: "Make Orders",
                desc: "Select products and request a detailed quote within minutes.",
                icon: "📄",
              },
              {
                title: "Confirm Order",
                desc: "Review quotation, confirm payment, and schedule your delivery.",
                icon: "✅",
              },
              {
                title: "Receive Delivery",
                desc: "Sit back and relax while we deliver to your site, on time.",
                icon: "🚚",
              },
            ].map(({ title, desc, icon }, idx) => (
              <div key={idx} className="flex flex-col items-start">
                <div className="text-4xl mb-4">{icon}</div>
                <h4 className="font-bold text-xl mb-2">{title}</h4>
                <p className="text-gray-600 text-sm">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stay in the Loop */}
      <section className="bg-[#ae3e34] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="flex flex-col items-center space-y-4">
            <div className="text-5xl">📢</div>
            <h2 className="text-3xl font-bold">Stay in the Loop</h2>
            <p className="text-sm max-w-xl">
              We're always working to bring you the best deals, quality
              products, and industry insights. Keep visiting our website or
              follow us on social media for the latest updates and offers.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
